module.exports = "<div class=\"image-wrapper\">\r\n  <div class=\"image-content\"\r\n    [style.background]=\"getImageUrl()\"\r\n    [@imgState]=\"imgState\">\r\n    \r\n    <div class=\"arrow-container\">\r\n      <div class=\"left-arrow arrow\" (click)=\"parent.goLeft()\">\r\n        <img src=\"assets/images/icons/arrows/left.png\">\r\n      </div>\r\n\r\n      <div class=\"right-arrow arrow\" (click)=\"parent.goRight()\">\r\n        <img src=\"assets/images/icons/arrows/right.png\">\r\n      </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/img-slider/slider-image/slider-image.component.html
// module id = 785
// module chunks = 1